import { render, staticRenderFns } from "./FootBottom.vue?vue&type=template&id=6f66aeb0&scoped=true"
import script from "./FootBottom.vue?vue&type=script&lang=js"
export * from "./FootBottom.vue?vue&type=script&lang=js"
import style0 from "./FootBottom.vue?vue&type=style&index=0&id=6f66aeb0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f66aeb0",
  null
  
)

export default component.exports